import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useAxiosLoader } from './plugins/axios'
import LoadingOverlay from 'react-loading-overlay-ts';

const GlobalLoader = () => {
  const [loading] = useAxiosLoader();
  console.log("environment -> ",process.env)
  
  return(
    <React.StrictMode>
      <LoadingOverlay active={loading} spinner text='Please wait...' styles={
          {
            overlay: (base) => ({
            ...base,
            background: 'rgba(211,211,211, 0.5)' }),
            spinner: (base) => ({
              ...base,
              width: '100px',
              '& svg circle': {
                stroke: 'rgba(255, 0, 0, 0.9)'
              }
            }),
            content: (base) => ({
              ...base,
              color : 'rgba(255, 0, 0, 0.9)'
              }
            )
          }
        }>
        <App />
      </LoadingOverlay>
    </React.StrictMode>
  );
}

ReactDOM.render(
  <GlobalLoader />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
